import React, { useState, useEffect } from 'react';

import { styled } from 'themes';

import { connect } from 'react-redux';
import Map from './components/map/map';
import PublicActivity from './components/public-activity';
import { device } from 'themes/media-queries';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

const InsideYepstr = ({ userLocations }) => {
  const { t } = useTranslation();
  const [publicItems, setPublicItems] = useState([]);

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await axios(
          'https://backend.yepstr.com/public-activity-items/items'
        );
        const data = await response.data;
        setPublicItems(data.items);
      } catch (error) {
        console.log(error);
      }
    }
    fetchData();
  }, []);

  return (
    <Wrapper>
      <Heading>{t('inside-yepstr.heading')}</Heading>
      <SubHeading>
        {t('inside-yepstr.subheading', {
          yepCount: userLocations.yepCount,
          customerCount: userLocations.customerCount,
        })}
      </SubHeading>
      <Container>
        <MapWrapper>
          <Map userLocations={userLocations} />
        </MapWrapper>
        {publicItems.length > 0 && (
          <PublicActivityWrapper>
            <PublicActivity items={publicItems} />
          </PublicActivityWrapper>
        )}
      </Container>
    </Wrapper>
  );
};

export default connect((state, props) => ({
  userLocations: state.mapReducer.userLocations,
}))(InsideYepstr);

const Wrapper = styled.section`
  grid-column: center-start / center-end;

  @media ${device.tablet} {
    grid-column: full-start / full-end;
  }
`;

const Heading = styled.h2`
  margin-bottom: 1rem;

  @media ${device.tablet} {
    margin-left: 6rem;
    margin-right: 6rem;
  }

  @media ${device.mobileL} {
    margin-left: 3rem;
    margin-right: 3rem;
  }
`;

const SubHeading = styled.p`
  font-size: 2.5rem;
  margin-bottom: 2rem;

  @media ${device.tablet} {
    margin-left: 6rem;
    margin-right: 6rem;
  }

  @media ${device.mobileL} {
    margin-left: 3rem;
    margin-right: 3rem;
  }
`;

const Container = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-template-rows: repeat(8, 10rem);

  margin-top: -10rem;
  margin-bottom: -10rem;

  @media ${device.laptopL} {
    margin-top: 0rem;
    margin-bottom: 0rem;
  }

  @media ${device.mobileL} {
    grid-template-rows: repeat(8, 9rem);
  }
`;

const MapWrapper = styled.div`
  grid-column: 1 / -1;
  grid-row: 2 / 8;

  position: relative;
  width: 100%;

  @media ${device.laptopL} {
    grid-row: 1 / 8;
  }
  @media ${device.tablet} {
    grid-row: 1 / -1;
  }
`;

const PublicActivityWrapper = styled.div`
  grid-column: 10 / 13;
  grid-row: 1 / -1;
  overflow: hidden;
/*
  @media ${device.laptopL} {
    grid-column: 9 / 12;
  } */

  @media ${device.laptopL} {
    grid-column: 1 / -1;
    grid-row: 6 / span 3;
  }

  @media ${device.mobileL} {
    grid-row: 6 / span 3;
  }
`;
